export default "__VITE_ASSET__CQjyw$dN__"